// extracted by mini-css-extract-plugin
export default {"BarGroup":"BarGroup--n74j9"};